import React, { FC, useCallback } from 'react';
import cn from 'classnames';

import { parseOfficePhones } from '@/utils';
import Icon from '../Icon';
import style from './style.module.scss';

export type TOffice = {
  id: string;
  dealerStaticId: string;
  dealerCenterStaticId: string;
  name: string;
  address: string;
  city: string;
  phone: string;
  url: string;
  location: {
    coordinates: [number, number];
  };
};

type TProps = {
  offices: TOffice[];
  activeOfficeId: number;
  setActiveOffice: (id: number) => void;
  className?: string;
};

const CarOfficeCard: FC<TProps> = ({
  className,
  offices,
  activeOfficeId,
  setActiveOffice,
}) => {
  const isSeveralOffices = offices.length > 1;
  const office = offices[activeOfficeId];
  const officePhones = parseOfficePhones(office.phone);

  const showNextOffice = useCallback(() => {
    const id = offices[activeOfficeId + 1] ? activeOfficeId + 1 : 0;

    setActiveOffice(id);
  }, [offices, activeOfficeId]);

  const showPrevOffice = useCallback(() => {
    const id = activeOfficeId - 1 < 0 ? offices.length - 1 : activeOfficeId - 1;

    setActiveOffice(id);
  }, [offices, activeOfficeId]);

  return (
    <div className={cn(style.card, className)}>
      <div className={style.cardTop}>
        <p className={style.cardTitle}>{office.name}</p>
        {isSeveralOffices && (
          <div className={style.cardControls}>
            <Icon
              name="arrow-right"
              className={cn(style.iconControl, style.iconControlLeft)}
              onClick={showPrevOffice}
            />
            <Icon
              name="arrow-right"
              className={style.iconControl}
              onClick={showNextOffice}
            />
          </div>
        )}
      </div>

      <div className={style.cardRow}>
        <div className={style.cardColLeft}>
          <Icon name="pin" className={style.cardIcon} /> <span>Адрес:</span>
        </div>
        <div>{office.address}</div>
      </div>
      <div className={style.cardRow}>
        <div className={style.cardColLeft}>
          <Icon name="phone" className={style.cardIcon} />
          <span>Телефон:</span>
        </div>
        <div>
          {officePhones.map(phone => (
            <div>
              <a href={`tel:${phone}`} className={style.cardLink}>
                {phone}
              </a>
            </div>
          ))}
        </div>
      </div>
      {Boolean(office.url) && (
        <div className={style.cardRow}>
          <div className={style.cardColLeft}>
            <Icon name="circle-arrow" className={style.cardIcon} />{' '}
            <span>Сайт:</span>
          </div>
          <div>
            <a
              className={style.cardLink}
              href={office.url}
              target="_blank"
              rel="noreferrer"
            >
              {office.url}
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default CarOfficeCard;
